import { RFIconProps } from "../types";

export default function CheckedIcon(props: RFIconProps) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect x="0.5" y="0.5" width="15" height="15" rx="2.5" fill="currentColor" stroke="currentColor" />
			<path
				d="M5 8.10138L7.06452 10.6267L11.1382 6"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="block dark:hidden"
			/>
			<path
				d="M5 8.10138L7.06452 10.6267L11.1382 6"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="dark:block hidden"
			/>
		</svg>
	);
}
